import React from 'react'
import classnames from 'classnames'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Pagination, Autoplay } from 'swiper'

import Card from '../Card'

import * as styles from './index.module.less'
import 'swiper/swiper.min.css'
import 'swiper/components/pagination/pagination.min.css'

SwiperCore.use([Pagination, Autoplay])

interface CardProps {
  title: string
  desc: string
  cover: any
}

interface CardListProps {
  className?: string
  cardClassName?: string
  iconClassName?: string
  descClassName?: string
  datas?: Array<CardProps>
  xGap: number
  mXGap?: number
  yGap?: number
  mYGap?: number
  coverWidth?: number
  coverHeight?: number
  titleColor?: string
  autoplay?: boolean
  isHeight?: boolean
}
const CardList: React.FC<CardListProps> = (props) => {
  const {
    className,
    cardClassName,
    iconClassName,
    descClassName,
    datas = [],
    titleColor,
    xGap = 20,
    mXGap = 40,
    mYGap = 0,
    yGap = 20,
    coverWidth,
    coverHeight,
    autoplay = false,
    isHeight = true,
  } = props

  const cnames = classnames(styles.CardList, className)
  return (
    <div className={cnames}>
      <div className="hidden lg:flex lg:flex-wrap lg:justify-center lg:mb-[40px] ">
        {datas.map((card, index) => (
          <Card
            isHeight={isHeight}
            key={index}
            style={{
              paddingLeft: xGap,
              paddingRight: xGap,
              marginTop: yGap,
            }}
            className={classnames('basis-[33.33%]', cardClassName)}
            iconClassName={iconClassName}
            cover={card?.cover?.publicURL || card?.cover}
            coverWidth={coverWidth}
            coverHeight={coverHeight}
            title={card.title}
            desc={card.desc}
            titleColor={titleColor}
          />
        ))}
      </div>

      {/* mobile */}
      <div className="lg:hidden mb-[20px] mt-[2rem]">
        <Swiper
          autoplay={autoplay}
          pagination={{
            el: '.my-pagination',
            type: 'custom',
            renderCustom: function (swiper, current, total) {
              let paginationHtml = ''
              for (let i = 0; i < total; i++) {
                if (i === current - 1) {
                  paginationHtml +=
                    '<span class="inline-block w-[10px] h-[10px] bg-primary border-[1px] border-primary mr-[6px] rounded-full"></span>'
                } else {
                  paginationHtml +=
                    '<span class="inline-block w-[10px] h-[10px] bg-sd-grey mr-[6px] rounded-full border-sd-grey border-[1px]"></span>'
                }
              }
              return paginationHtml
            },
          }}
        >
          {datas.map((card, index) => (
            <SwiperSlide key={index}>
              <Card
                style={{
                  paddingLeft: mXGap,
                  paddingRight: mXGap,
                  marginTop: mYGap,
                }}
                cover={card?.cover?.publicURL || card?.cover}
                coverWidth={coverWidth}
                coverHeight={coverHeight}
                iconClassName={iconClassName}
                title={card.title}
                desc={card.desc}
                titleColor={titleColor}
                isHeight={isHeight}
                descClassName={descClassName}
              />
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="my-pagination flex justify-center mt-[10px]"></div>
      </div>
    </div>
  )
}

export default CardList
